import React, { MouseEvent } from "react"

import { useAccount, useLayerPopupContext } from "@shared/contexts"

interface Props {
  scheduleId: number
  title?: string
}

/**
 * 녹화방송을 와우넷 홈페이지의 방송 실행(Execute) 경로로 여는 링크.
 * 와우넷에서 인증을 처리한 뒤 우리 VOD를 알아서 연동한다.
 * (익명 사용자는 로그인 유도 팝업을 띄운다)
 */
export default function WownetExecuteLink({
  scheduleId,
  title = "보기",
}: Props) {
  const { open } = useLayerPopupContext()
  const { account } = useAccount()

  // 로그인을 안 한 사용자면 로그인이 필요하다는 문구 보여줘야 함 - 기존 동작 방식
  const isAnonymous = account?.viewer?.role === "ANONYMOUS"

  const url = `https://www.wownet.co.kr/Common/Bcast/Execute?id=${scheduleId}`

  return (
    <a
      href={url}
      rel="noreferrer"
      title={title}
      onClick={(e: MouseEvent) => {
        e.preventDefault()

        if (isAnonymous) {
          return open("ANONYMOUS")
        }

        // 새 탭이 아니라 새 창으로 띄운다
        const { availWidth, availHeight } = (window as any).screen
        const option =
          "fullscreen=yes,location=no,menubar=no,status=no,toolbar=no,directories"

        return window.open(
          url,
          title,
          `width=${availWidth},height=${availHeight},${option}`,
        )
      }}
    >
      {title}
    </a>
  )
}
